// extracted by mini-css-extract-plugin
export default {"container":"_2iIDp"};